import React, { memo, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DefaultView from "../components/DefaultView";
import EmailLeftbar from "../components/EmailLeftbar";
import FaxCoverTableRow from "../components/FaxCoverTableRow";
import { actionGetReceivedMessages } from "../store/actions/inboxAction";
import { actionGetFaxCover } from "../store/actions/settingAction";
import EmptyResult from "../components/EmptyResult";

const FaxCovers = ({
  actionGetFaxCover,
  user,
  faxCoverData,
  faxCoverloder,
}) => {
  useEffect(() => {
    actionGetFaxCover();
  }, [actionGetFaxCover]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* start page title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0 main_heading">Fax Cover</h4>
              <div className="page-title-right">
                <DefaultView />
              </div>
            </div>
            {/* <div className="d-flex justify-content-end mb-3">
              <div className="btn-group float-end">
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-left" />
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-success waves-effect"
                >
                  <i className="fa fa-chevron-right" />
                </button>
              </div>
            </div> */}
          </div>
        </div>
        {/* end page title */}
        <div className="row">
          <div className="col-12">
            {/* Left sidebar */}
            <EmailLeftbar />
            {/* End Left sidebar */}

            {/* Right Sidebar */}
            <div className="email-rightbar mb-3 compose-section">
              <div className="card">
                <div
                  className="btn-toolbar p-3 d-flex justify-content-between align-items-start"
                  role="toolbar"
                >
                  <div className="flex-grow-1">
                    <div className="mb-2">
                      <div className="fs-6 text-dark mb-1">Manage your fax cover templates for professional communications.</div>
                      <div className="text-muted small">Create, customize, and organize cover pages that will be automatically attached to your outgoing fax messages.</div>
                    </div>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-info-circle me-2 text-primary"></i>
                      <span className="text-muted small">
                        <span className="fw-medium">Note:</span> To update your cover data, kindly remove the existing record and create a new one.
                      </span>
                    </div>
                  </div>
                  <div className="ms-3">
                    <Link
                      to="/fax-covers/create"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="fa fa-plus me-2" /> Add
                    </Link>
                  </div>
                </div>
                <div className="card-body">
                  {(
                    <div className="table-responsive">
                      <table className="table table-editable table-nowrap align-middle table-edits">
                        <thead>
                          <tr style={{ cursor: "pointer" }}>
                            <th>Company Name</th>
                            <th>Company Number</th>
                            <th>Created At</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {faxCoverloder &&
                            [...Array(5)].map((_, i) => (
                              <tr key={i}>
                                <td>
                                  <div
                                    className="skeleton py-2"
                                    style={{ width: "80%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "60%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "70%" }}
                                  />
                                </td>
                                <td>
                                  <div
                                    className="skeleton"
                                    style={{ width: "40%" }}
                                  />
                                </td>
                              </tr>
                            ))}
                          {faxCoverData &&
                            faxCoverData.map((data, index) => (
                              <FaxCoverTableRow
                                key={index}
                                id={data.cover_ID}
                                date={data.cover_addTime}
                                name={data.company_name}
                                number={data.company_number}
                              />
                            ))}
                          {!faxCoverloder &&
                            faxCoverData &&
                            faxCoverData.length == 0 &&
                            <tr>
                              <td colSpan={5}>
                                <EmptyResult title={"No Fax Cover Data Found"}
                                  description={`You currently have no fax covers. Click "Add" to create a new cover.`} />
                              </td>
                            </tr>}
                        </tbody>
                      </table>
                    </div>
                  )}

                </div>
              </div>
              {/* card */}
            </div>
            {/* end  Right Sidebar Col-9 */}
          </div>
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    getReceivedMessagesLoader: state.inbox.getReceivedMessagesLoader,
    receivedMessages: state.inbox.receivedMessages,
    user: state.auth.user,
    faxCoverData: state.setting.faxCoverData,
    faxCoverloder: state.setting.faxCoverloder,
  };
};

export default connect(mapStateToProps, {
  actionGetReceivedMessages,
  actionGetFaxCover,
})(FaxCovers);
